import React, { useState } from "react";
export const BasePage = ({
  permission,
  children,
}: {
  permission: boolean;
  children: React.ReactNode;
}) => {
  if (!permission) {
    return (
      <h2>
        You do not have permission to access this page. If needed, contact
        MamFam support.
      </h2>
    );
  }
  return <>{children}</>;
};
